import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePayment } from '../../../../contexts/PaymentContext';
import PaymentForm from '../PaymentForm/PaymentForm';
import './PaymentSection.scss';
import SvgIcons from '../../../../services/SvgIcons';
import MainGoal from '../MainGoal/MainGoal';

export default function PaymentSection({workshopPaymentSection, training, cancelBtn, workshop}) {
    const navigate = useNavigate();
    const { paymentStatus } = usePayment();
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [showPaymentForm, setShowPaymentForm] = useState(true);

    // Initialiser avec le plan global par défaut
    useEffect(() => {
        if (training?.PageDePaiement && !selectedPlan) {
            const defaultPlan = {
                type: 'global',
                amount: training.PageDePaiement.TarifGlobal,
                installments: 1,
                description: 'Paiement unique'
            };
            setSelectedPlan(defaultPlan);
        }
    }, [training, selectedPlan]);

    // Si le paiement est réussi, rediriger vers la confirmation
    useEffect(() => {
        if (paymentStatus.success) {
            navigate('/paiement/confirmation', {
                state: {
                    success: true,
                    amount: paymentStatus.amount,
                    paymentId: paymentStatus.paymentId,
                    plan: selectedPlan
                }
            });
        }
    }, [paymentStatus.success, navigate, paymentStatus.amount, paymentStatus.paymentId, selectedPlan]);

    const handleCancelPayment = () => {
        setShowPaymentForm(false);
        cancelBtn();
    };

    console.log('Enhanced PaymentSection rendered:', {
        training: !!training,
        selectedPlan,
        showPaymentForm
    });

    if (!training?.PageDePaiement) {
        return (
            <div className='workshop-payment-section'>
                <div className='workshop-payment-section__error'>
                    ❌ Configuration de paiement manquante
                </div>
            </div>
        );
    }

    return (
        <div className='workshop-payment-section'>
            {workshopPaymentSection.find(item => item.__component === "atelier.maingoal") && (
                <MainGoal content={workshopPaymentSection.find(item => item.__component === "atelier.maingoal")} isAtelier={true} />
            )}
            
            <div className='workshop-payment-section__content'>
                {/* Bloc des informations du programme */}
                <div className='workshop-payment-section__program-block'>
                    <div className='workshop-payment-section__program-block__fare_box'>
                        <span className='workshop-payment-section__program-block__fare'>
                            {training.PageDePaiement.TarifGlobal} €
                        </span>
                        
                        {training.PageDePaiement.Mensualites?.length > 0 && (
                            <ul>
                                {training.PageDePaiement.Mensualites.map((item, index) => (
                                    <li key={index}>
                                        <span className='workshop-payment-section__program-block__fare2times'>
                                            ou {item.TarifParMois} € x {item.NbMensualite}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        )}
                    </div>
                    
                    <ul className='workshop-payment-section__program-block__list'>
                        {training.PageDePaiement.Livrables?.map((item, index) => (
                            <li key={index}>{item.Livrable}</li>
                        ))}
                    </ul>
                </div>

                {/* Bloc de paiement avec sélecteur */}
                <div className='workshop-payment-section__payment-block'>
                    {paymentStatus.isProcessing ? (
                        <div className="workshop-payment-section__loading">
                            <SvgIcons
                                name="loading"
                                width="32"
                                height="32"
                                color="#6D4F47"
                            />
                            <p>Traitement en cours...</p>
                        </div>
                    ) : (
                        <>
                            {/* Formulaire de paiement */}
                            {selectedPlan && showPaymentForm && (
                                <div className="workshop-payment-section__payment-form">
                                    <PaymentForm
                                        selectedPlan={selectedPlan}
                                        productId="formation-workshop"
                                        workshop_infos={{
                                            id: workshop.id,
                                            title1: workshop.title1,
                                            title2: workshop.title2,
                                            bkg: workshop.bkg
                                        }}
                                        onCancel={handleCancelPayment}
                                        training={training}
                                    />
                                </div>
                            )}
                        </>
                    )}

                    {paymentStatus.error && (
                        <div className="workshop-payment-section__error">
                            ❌ {paymentStatus.error}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}